<ion-searchbar
  #searchBar
  autofocus
  placeholder="Search entities"
  mode="md"
  [(ngModel)]="searchTerm"
  (ionInput)="search($event.target.value)"
></ion-searchbar>

<ion-content #content>
  <ion-list inset="false" lines="none">
    <ion-item
      *ngFor="let location of usersLocationArray"
      (click)="onDismiss(location)"
    >
      <ion-label>{{location.locationName}}</ion-label>
    </ion-item>
  </ion-list>

  <!-- <ion-virtual-scroll [items]="usersLocationArray" lines="none" inset="false">
    <ion-item *virtualItem="let location" (click)="onDismiss(location)">
      <ion-label>{{location.locationName}}</ion-label>
    </ion-item>
  </ion-virtual-scroll> -->

  <ion-infinite-scroll
    #infiniteScroll
    threshold="10px"
    (ionInfinite)="loadData($event)"
  >
    <ion-infinite-scroll-content loadingSpinner="">
      <div class="loader-container">
        <ion-icon src="./assets/icon/Loader.svg"></ion-icon>
      </div>
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
